// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import styles from './styles.scss';

import { getCategory, getAttributes } from '../../utils/methods.js';

import { preloader } from '../../utils/animation';

import type { AttributeType, CategoryType } from '../../api/types';
import type { DefaultStateType } from '../../redux/reducers';

type Props = {
  categories: Array<CategoryType>,
};

class Cafe extends React.Component<Props> {
  componentDidMount() {
    preloader().play();
    if (document && document.body) {
      document.body.classList.add('cafe');
    }
  }

  componentWillUnmount() {
    if (!document || !document.body) return;

    document.body.classList.remove('cafe');
  }

  showPDF = (menu: ?AttributeType) => {
    if (menu && menu.value) {
      window.open(menu.value);
    }
  };

  render() {
    const { categories } = this.props;

    if (!categories) {
      return <div>loading...</div>;
    }

    const category: ?CategoryType = getCategory(categories, 'cafe');
    const attributes: Array<AttributeType> = getAttributes(category);

    const bg = attributes.find(attr => attr.name.toLocaleLowerCase().includes('background'));
    const img1 = attributes.find(attr => attr.name.toLocaleLowerCase().includes('image 1'));
    const img2 = attributes.find(attr => attr.name.toLocaleLowerCase().includes('image 2'));
    const title = attributes.find(attr => attr.name.toLocaleLowerCase().includes('title'));
    const description = attributes.find(attr => attr.name.toLocaleLowerCase().includes('description'));
    const menu = attributes.find(attr => attr.type === 'file' && attr.name.toLowerCase().includes('menu'));

    return (
      <React.Fragment>
        <div className={styles.hero} style={{ backgroundImage: `url(${bg ? bg.value : ''})` }}>
          <div className={styles.title}>
            <h1>Cafe</h1>
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles['flex-row']}>
            <div className="figure">
              <div className="img-cover">
                <img src={img1 ? img1.value : null} alt={img1 ? img1.name : null} />
                <div className="sail" />
              </div>
            </div>

            <div className={styles.description}>
              <h3 dangerouslySetInnerHTML={{ __html: title ? title.value : null }} />
              <p>{description ? description.value : null}</p>
            </div>
          </div>
          <div className={classnames(styles.alignRight, 'img-cover')}>
            <img src={img2 ? img2.value : null} alt={img2 ? img2.name : null} />
            <div className="sail" />
          </div>
        </div>
        <div className={styles['show-menu']}>
          <h4>New updated menu</h4>
          <div className="btn">
            <span onClick={() => this.showPDF(menu)}>View PDF</span>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: DefaultStateType) => ({ categories: state.categories });

export default connect(mapStateToProps)(Cafe);



// WEBPACK FOOTER //
// ./src/pages/Cafe/index.js